// extracted by mini-css-extract-plugin
var _1 = "KeyboardShortcutsModal-module__active--yZ9UD";
var _2 = "KeyboardShortcutsModal-module__animateUploadProgressBarWidth--LNlF0";
var _3 = "KeyboardShortcutsModal-module__animatedBackground--gVv0p";
var _4 = "KeyboardShortcutsModal-module__container--Q2SwE";
var _5 = "KeyboardShortcutsModal-module__orWrapper--cHSVB";
var _6 = "KeyboardShortcutsModal-module__sectionTab--UdBAK";
var _7 = "KeyboardShortcutsModal-module__sectionTabs--G5ysJ";
var _8 = "KeyboardShortcutsModal-module__sections--oTctm";
export { _1 as "active", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "container", _5 as "orWrapper", _6 as "sectionTab", _7 as "sectionTabs", _8 as "sections" }
